export default __webpack_public_path__ + "static/media/020_start.av1.225f5532.mp4";